import { createContext, useContext, useState, ReactNode } from 'react';

type TState = {
  diff: object | undefined;
};

const PageContext = createContext<TState>({
  diff: undefined,
});

type TProps = {
  children: ReactNode;
};

export const PageProvider = ({ children }: TProps) => {
  const [diff] = useState<object | undefined>();

  return <PageContext.Provider value={{ diff }}>{children}</PageContext.Provider>;
};

export const usePageContext = () => useContext(PageContext);
